import { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export interface PageContentProps {
  children: ReactNode;
  className?: string;
}

export function PageContent({ children, className = "" }: PageContentProps) {
  return <div className={cn("relative pt-8 px-8 pb-8 flex-1 flex flex-col min-h-0", className)}>{children}</div>;
}
